import React from 'react';

//mui
import { Box } from '@mui/material';

const Loading = () => {
  return (
    <Box className="loading">
      <Box className="c1"></Box>
      <Box className="c2"></Box>
      <Box className="c3"></Box>
      <Box className="c4"></Box>
    </Box>
  );
};

export default Loading;
